import * as React from 'react';
import { connect } from 'react-redux';
import { useOktaAuth } from '@okta/okta-react';
import { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import * as RCNGWindow from '../components/sharedcomponents/ConfirmationWindow';
import { RCUtils } from '../RCUtils';

var Config: any = require('../Config.json');


const OktaRedirectHome = () => {
    var preloader = document.getElementById("preloader");
    preloader.classList.add("hidden");
    const { oktaAuth, authState } = useOktaAuth();
    const [userInfo, setUserInfo] = useState(null);
    const [hideWelcomeInfo, sethideWelcomeInfo] = useState(false);
    const [rightsInfo, setrightsInfo] = useState(false);

    const history = useHistory();
    //    const { authState, oktaAuth } = useOktaAuth();
    //    const login = () => oktaAuth.signInWithRedirect({ originalUri: "/profile" });
    useEffect(() => {
        if (authState && !authState.isAuthenticated) {
            // When user isn't authenticated, forget any user info
            setUserInfo(null);
        } else if (authState && authState.isAuthenticated) {
            oktaAuth.getUser().then((info) => {
                setUserInfo(info);
                if (sessionStorage.getItem("OIN") != null) {
                    const TemplateUrl = Config.ApiBaseUrl + '/api/AuthUser/ValidateOINOktaUser';
                    var requestHeaders = new Headers();
                    requestHeaders.append('pragma', 'no-cache');
                    requestHeaders.append('cache-control', 'no-cache');
                    requestHeaders.append('Accept', 'application/json');
                    requestHeaders.append('Content-Type', 'application/json');
                    fetch(TemplateUrl, {
                        method: 'POST',
                        headers: requestHeaders,
                        body: JSON.stringify({ "Username": info.email })
                    })
                        .then(response => response.json() as Promise<server.UserLoginDetails>)
                        .then(data => {
                            if (data.Errmsg == null || data.Errmsg == "") {
                                var userDetailInfo = JSON.parse(JSON.stringify(data));
                                if (userDetailInfo != null && userDetailInfo.User != null && userDetailInfo.User != undefined) {
                                    sessionStorage.setItem('JWTToken', userDetailInfo.JWTToken);
                                    sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                                    localStorage.setItem('login_status', 'logged_in' + '&' + JSON.stringify(userDetailInfo.User.UserName));
                                    sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                                    var userInfo = JSON.stringify({
                                        'Username': userDetailInfo.User.UserName, 'IsAccountLocked': userDetailInfo.IsAccountLocked, 'IsLoggedIn': true,
                                        'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                        'LoginAttempts': userDetailInfo.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd,
                                        'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                        'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                        'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
                                        'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                        'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                                    });
                                    sessionStorage.setItem('UserInfo', userInfo);
                                    if (userDetailInfo.User.OKTASignInOverrideOption == "D") {
                                        var welcomeText = document.getElementById("welcomeText");
                                        welcomeText.classList.add("hidden");
                                        var loaderimg = document.getElementById("loaderImg");
                                        loaderimg.classList.add("hidden");
                                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in disallowed', 'Okta sign-in is disallowed. You will now be redirected to the standard Maritime platform sign-in page at ' + window.location.origin + '.', onOKSubmitDisAllow.bind(this));
                                    } else if ((userDetailInfo.User.OKTASignInOverrideOption == "A") || (userDetailInfo.User.OKTASignInOverrideOption == "R")) {
                                        history.push('/home');
                                        //history.push('/profile');
                                        //window.location.replace('/home');
                                    }
                                } else {
                                    var loader = document.getElementById("loaderImg");
                                    loader.classList.add("hidden");
                                    sethideWelcomeInfo(true);
                                }
                            }
                            else {
                                var loaderimg = document.getElementById("loaderImg");
                                loaderimg.classList.add("hidden");
                                // PopupWindow.showErrorMessage("Login", data.Errmsg);
                                setrightsInfo(true);
                            }
                        }).catch((error) => {
                            console.log("error" + error);
                        });

                } else {
                    sessionStorage.setItem('JWTToken', oktaAuth.getAccessToken());
                    var url = Config.ApiBaseUrl + '/api/AuthUser/ValidateOktaUser';
                    var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
                    fetch(request)
                        .then(RCUtils.handleOktaError)
                        .then(response => response.json() as Promise<server.UserLoginDetails>)
                        .then(data => {
                            if (data.Errmsg == null || data.Errmsg == "") {
                                var userDetailInfo = JSON.parse(JSON.stringify(data));
                                if (userDetailInfo != null && userDetailInfo.User != null && userDetailInfo.User != undefined) {
                                    sessionStorage.setItem("userRights", JSON.stringify(userDetailInfo.User.Customer.Rights));
                                    localStorage.setItem('login_status', 'logged_in' + '&' + JSON.stringify(userDetailInfo.User.UserName));
                                    sessionStorage.setItem("customerDetails", JSON.stringify(userDetailInfo.User.Customer));

                                    var userInfo = JSON.stringify({
                                        'Username': userDetailInfo.User.UserName, 'IsAccountLocked': userDetailInfo.IsAccountLocked, 'IsLoggedIn': true,
                                        'TemperatureRoundPrecision': userDetailInfo.User.TemperatureRoundPrecision, 'SpeedUnitCd': userDetailInfo.User.Customer.SpeedUnitCd,
                                        'LoginAttempts': userDetailInfo.LoginAttempts, 'TemperatureUnitCd': userDetailInfo.User.Customer.preferenceDetails.TemperatureUnitCd,
                                        'TimeZoneOffSet': userDetailInfo.User.Customer.preferenceDetails.TimeZoneOffSet, 'TimeZoneCd': userDetailInfo.User.Customer.preferenceDetails.TimeZoneCd,
                                        'LogonUri': userDetailInfo.User.Customer.LogoUri, 'UserEmail': userDetailInfo.User.UserEmail, 'CustomerId': userDetailInfo.User.Customer.CustomerId, 'UserId': userDetailInfo.User.UserId,
                                        'IsCustomAttributesEnable': userDetailInfo.IsCustomAttributesEnable, 'ShowSaveSearchOnLoad': userDetailInfo.User.ShowSaveSearchOnLoad, 'ShowMapPinsWithRunState': userDetailInfo.User.ShowMapPinsWithRunState,
                                        'CustomerFenceTypeCd': userDetailInfo.CustomerFenceTypeCd, 'OKTASignInOverrideOption': userDetailInfo.User.OKTASignInOverrideOption, 'SSOSignInType': userDetailInfo.User.Customer.SSOSignInTypes, 'IsEnableServerSide': userDetailInfo.User.IsEnableServerSide,
                                        'GravityVectorPrecision': userDetailInfo.User.GravityVectorPrecision
                                    });
                                    sessionStorage.setItem('UserInfo', userInfo);
                                    if (userDetailInfo.User.OKTASignInOverrideOption == "D") {
                                        var welcomeText = document.getElementById("welcomeText");
                                        welcomeText.classList.add("hidden");
                                        var loaderimg = document.getElementById("loaderImg");
                                        loaderimg.classList.add("hidden");
                                        RCNGWindow.ConfirmWindow.showConfirmBoxOK('Okta sign-in disallowed', 'Okta sign-in is disallowed. You will now be redirected to the standard Maritime platform sign-in page at ' + window.location.origin + '.', onOKSubmitDisAllow.bind(this));
                                    } else if ((userDetailInfo.User.OKTASignInOverrideOption == "A") || (userDetailInfo.User.OKTASignInOverrideOption == "R")) {
                                        //history.push('/profile');
                                        history.push('/home');
                                        //window.location.replace('/home');
                                    }
                                } else {
                                    var loader = document.getElementById("loaderImg");
                                    loader.classList.add("hidden");
                                    sethideWelcomeInfo(true);
                                }
                            }
                            else {
                                var loaderimg = document.getElementById("loaderImg");
                                loaderimg.classList.add("hidden");
                                // PopupWindow.showErrorMessage("Login", data.Errmsg);
                                setrightsInfo(true);
                            }
                        }).catch((error) => {
                            console.log("error" + error);
                        });
                }
            });
        }
    }, [authState, oktaAuth]);
    //}, []);


    const onOKSubmitDisAllow = () => {
        if (localStorage.length > 0) {
            localStorage.clear();
        }
        if (sessionStorage.length > 0) {
            sessionStorage.clear();
        }
        window.location.href = "/";
    }

    const login = () => {
        //authService.login('/');
        // oktaAuth.signIn('/');
        oktaAuth.signInWithRedirect();
    };


    if (!authState) {
        return (
            <div>Loading Please Wait ......  </div>
        );
    }
    return (
        //let oktabaseURI = window.location.href;
        <React.Fragment>
            <div id='preloader'>
                <img id='loaderImg' className="loader" src='../../images/OrbcommLogoLoading.png' alt='Logo' width="50" />
                {!hideWelcomeInfo && authState.isAuthenticated && !userInfo
                    && <div className="loading-text">Loading information... Please Wait....</div>}
                {!hideWelcomeInfo && authState.isAuthenticated && userInfo && authState.accessToken != null
                    && (
                        <div id='welcomeText'>
                            <div className='loading-text'>
                                Welcome {userInfo.name}!
                            </div>
                        </div>
                    )}
                {hideWelcomeInfo && (
                    <div className="preloaderColumn">
                        <div className="rediret alert alert-info">The platform cannot find a local account that matches this Okta account.</div>
                    </div>
                )}
                {rightsInfo && (
                    <div className="preloaderColumn">
                        <div className="rediret alert alert-info">Your access rights have been revoked or you have not been assigned any access group. Please contact your Administrator.</div>
                    </div>
                )}
                {!authState.isAuthenticated
                    && (
                        //authService.login('/')
                        //oktaAuth.signIn('/')
                        oktaAuth.signInWithRedirect()
                    )}
            </div>
        </React.Fragment>
    );
};

export default connect()(OktaRedirectHome);
